import React from 'react'
import GitHubCalendar from 'react-github-calendar'


const GithubCalender = () => {
  return (
    <div><GitHubCalendar username="harshank11" backgroundColor={"green"}  /></div>
  )
}

export default GithubCalender